import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@agenda-facil/ui';

export function UpdatePrompt() {
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div className="fixed inset-x-4 bottom-[calc(80px+env(safe-area-inset-bottom))] z-50 mx-auto flex max-w-md items-center justify-between gap-3 rounded-2xl border border-[var(--border)] bg-[var(--surface)] p-3 shadow-[var(--shadow-lg)]">
      <p className="pl-2 text-sm font-bold">Uma nova versão está pronta.</p>
      <div className="flex gap-1">
        <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>Depois</Button>
        <Button size="sm" onClick={() => void updateServiceWorker(true)}>Atualizar</Button>
      </div>
    </div>
  );
}
